import React from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import {logout} from '../actions/authActions';
import Dashboard from './Dashboard';
import History from './history/History';
import Browse from './directory/Browse';
import BrowseNode from './directory/BrowseNode';
import Footer from './layout/Footer';
import Header from './layout/Header';

const Layout = ({logout, wsStatus}) => (
    <>
        <Header onLogout={logout} wsStatus={wsStatus} />
        <div className="container-fluid main-content">
            <div className="row">
                <main role="main" className="col-md-12 ms-sm-auto mt-3 px-4">
                    <Switch>
                        <Route exact path="/"><Dashboard /></Route>
                        <Route exact path="/browse"><Browse /></Route>
                        <Route exact path="/browse/node/:nodeId"><BrowseNode /></Route>
                        <Route exact path="/history"><History /></Route>
                    </Switch>
                </main>
            </div>
        </div>
        <Footer />
    </>
);

const mapStateToProps = (state) => ({
    wsStatus: state.ws.status,
});

export default connect(mapStateToProps, {logout})(Layout);
